import React from 'react';

import { CinemaPartnerType } from '@cineamo/api/models/cinema-partner/CinemaPartnerType.enum';

import { IconBars24 } from '@cineamo/ui/src/icons/ic-bars';
import { IconHandshake24 } from '@cineamo/ui/src/icons/ic-handshake';
import { IconParking24 } from '@cineamo/ui/src/icons/ic-parking';
import { IconRestaurantLine24 } from '@cineamo/ui/src/icons/ic-restaurantLine';

export function getCinemaPartnerIcon(cinemaPartnerType: CinemaPartnerType): React.JSX.Element {
    switch (cinemaPartnerType) {
        case CinemaPartnerType.BAR:
            return <IconBars24 />;
        case CinemaPartnerType.RESTAURANT:
            return <IconRestaurantLine24 />;
        case CinemaPartnerType.PARKING:
            return <IconParking24 />;
        default:
            return <IconHandshake24 />;
    }
}
